import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { useSiteContent } from '@personal-portfolio/queries';
import { Header } from './header';
import { Sidebar } from './sidebar';
import { RightSidebar } from './right-sidebar';

export const Layout: React.FC = () => {
  const content = useSiteContent();
  return (
    <div className="min-h-dvh bg-background">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-100 focus:rounded-md focus:border focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground"
      >
        {content.system.skipToContent}
      </a>
      <ScrollRestoration />
      <Header />
      <Sidebar />
      <RightSidebar className="fixed top-14 right-0 hidden h-[calc(100dvh-3.5rem)] overflow-y-auto xl:block" />
      <main
        id="main"
        className="ml-0 min-h-[calc(100dvh-3.5rem)] pt-14 transition-transform duration-300 lg:ml-sidebar xl:mr-rightbar"
      >
        <div className="px-4 pt-6 pb-12">
          <div className="mx-auto max-w-4xl">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};
